var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value || _vm.params.value == false)?_c('div',{staticClass:"pill-wrap"},[_c('span',{staticClass:"text-center text-bold pill",class:{ 'blue-pill': _vm.trueFalse(_vm.params.value) }},[_vm._v(" "+_vm._s(_vm.normalizeValues(_vm.params.value))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }